// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3mI7_","image":"Header_image__3ubof","name":"Header_name__2Ifp2","info":"Header_info__3-f-f","infoRow":"Header_infoRow__jNb4V"};